import {useEffect,useState} from 'react'
import css from './Incrementer.module.css'

const Incrementer = ({value,onAdd,onSubtract,disableAdd,disableSubtract})=>{
	const [localValue,setLocalValue] = useState(value)
	useEffect(()=>{
		setLocalValue(value)
	},[value])
	return (
		<span className={css.Incrementer}>
			<button disabled={disableAdd} onClick={()=>{
				onAdd(localValue+1)
				setLocalValue(p=>p+1)
				
			}}>
				{!disableAdd&&
					<i className="fa fa-caret-up"/>
				}
			</button>
			<span className={css.Value}>{localValue}</span>
			<button disabled={disableSubtract} onClick={()=>{
				onSubtract(localValue+1)
				setLocalValue(p=>p-1)
			}}>
				{!disableSubtract&&
					<i className="fa fa-caret-down"/>
				}
			</button>
		</span>
	)
}

export default Incrementer